import { render, staticRenderFns } from "./fleg-comp-dividendos-a-distribuir.vue?vue&type=template&id=210d23a6&lang=html&"
import script from "./fleg-comp-dividendos-a-distribuir.vue?vue&type=script&lang=js&"
export * from "./fleg-comp-dividendos-a-distribuir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports